<template>
  <b-overlay :show="showOverlay" rounded="sm">
    <div class="auth-wrapper auth-v2">
      <b-row class="auth-inner m-0">
        <!-- Brand logo-->
        <b-link class="brand-logo">
          <vuexy-logo />
          <!--        <h2 class="brand-text text-primary ml-1">-->
          <!--          Vuexy-->
          <!--        </h2>-->
        </b-link>
        <!-- /Brand logo-->

        <!-- Left Text-->
        <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
          <div
            class="w-100 d-lg-flex align-items-center justify-content-center px-5"
          >
            <b-img fluid :src="imgUrl" alt="Login V2" />
          </div>
        </b-col>
        <!-- /Left Text-->

        <!-- Login-->
        <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
          <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
            <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
              به پنل فرمن خوش آمدید 👋
            </b-card-title>
            <b-card-text class="mb-2">
              لطفا به حساب کاربری خود وارد شوید.
            </b-card-text>

            <!-- form -->
            <validation-observer ref="loginForm" #default="{ invalid }">
              <b-form class="auth-login-form mt-2" @submit.prevent="login">
                <!-- email -->
                <b-form-group label="تلفن همراه" label-for="login-mobile">
                  <validation-provider
                    #default="{ errors }"
                    name="Mobile"
                    vid="mobile"
                    rules="required|integer"
                  >
                    <b-form-input
                      id="login-mobile"
                      :state="errors.length > 0 ? false : null"
                      v-model="mobile"
                      name="login-mobile"
                      placeholder="---------09"
                    />
                    <small v-if="errors.length > 0" class="text-danger">
                      شماره همراه باید حتما عدد باشد.
                    </small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">رمز عبور</label>
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="*****"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small v-if="errors.length > 0" class="text-danger">
                      فیلد رمز عبور الزامی است
                    </small>
                  </validation-provider>
                </b-form-group>
                <div class="my-1">
<!--                  <small> انتخاب منطقه زمانی </small>-->
<!--                  <template v-if="countryList">-->
<!--                    <v-select-->
<!--                      :clearable="false"-->
<!--                      dir="rtl"-->
<!--                      id="timezone"-->
<!--                      v-model="selectedTimeZone"-->
<!--                      :options="countryList"-->
<!--                      label="title"-->
<!--                      placeholder="انتخاب کنید"-->
<!--                      autocomplete="off"-->
<!--                    >-->
<!--                    </v-select>-->
<!--                  </template>-->
                  <!-- <v-select
                    :clearable="false"
                    class="w-full"
                    dir="rtl"
                    id="timezone"
                    v-model="selectedTimeZone"
                    :options="myTimeZoneArray"
                    @input="setNewTimezone"
                    label="title"
                    placeholder="انتخاب کنید"
                    autocomplete="off"
                  >
                  </v-select> -->
                </div>

                <!-- checkbox -->
                <!-- <b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                  >
                    مرا به خاطر بسپار
                  </b-form-checkbox>
                </b-form-group> -->

                <!-- submit buttons -->
<!--                :disabled="invalid || isLoginButtonDisabled"-->

                <b-button
                  type="submit"
                  variant="primary"
                  block
                >
                  ورود
                </b-button>
              </b-form>
            </validation-observer>

            <!--          <b-card-text class="text-center mt-2">-->
            <!--            <span>New on our platform? </span>-->
            <!--            <b-link :to="{name:'auth-register'}">-->
            <!--              <span>&nbsp;Create an account</span>-->
            <!--            </b-link>-->
            <!--          </b-card-text>-->

            <!--          &lt;!&ndash; divider &ndash;&gt;-->
            <!--          <div class="divider my-2">-->
            <!--            <div class="divider-text">-->
            <!--              or-->
            <!--            </div>-->
            <!--          </div>-->

            <!--          &lt;!&ndash; social buttons &ndash;&gt;-->
            <!--          <div class="auth-footer-btn d-flex justify-content-center">-->
            <!--            <b-button-->
            <!--              variant="facebook"-->
            <!--              href="javascript:void(0)"-->
            <!--            >-->
            <!--              <feather-icon icon="FacebookIcon" />-->
            <!--            </b-button>-->
            <!--            <b-button-->
            <!--              variant="twitter"-->
            <!--              href="javascript:void(0)"-->
            <!--            >-->
            <!--              <feather-icon icon="TwitterIcon" />-->
            <!--            </b-button>-->
            <!--            <b-button-->
            <!--              variant="google"-->
            <!--              href="javascript:void(0)"-->
            <!--            >-->
            <!--              <feather-icon icon="MailIcon" />-->
            <!--            </b-button>-->
            <!--            <b-button-->
            <!--              variant="github"-->
            <!--              href="javascript:void(0)"-->
            <!--            >-->
            <!--              <feather-icon icon="GithubIcon" />-->
            <!--            </b-button>-->
            <!--          </div>-->
          </b-col>
        </b-col>
        <!-- /Login-->
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import timezones from "./timezone.json";

import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BOverlay,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email, integer } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    BOverlay,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  created() {
    this.myTimeZoneArray = timezones;
  },
  mounted() {
    // this.getCountryLists();
  },
  data() {
    return {
      countryList: [],
      myTimeZoneArray: null,
      selectedTimeZone: 192,
      accessListForRole: null,
      status: "",
      password: "",
      mobile: "",
      showOverlay: false,
      // userEmail: 'admin@demo.com',
      sideImg: require("@/assets/images/pages/login-v2.svg"),

      // validation rules
      required,
      integer,
      signInErrors: {
        RecordNotFound: "یافت نشد",
        UserNotActive: "کاربر شما فعال نیست",
        WrongData: "اطلاعات اشتباه وارد شده است",
        UserNotShow: "غیر فعال شده است",
      },
      signInKeys: {
        Mobile: "شماره همراه",
        Email: "ایمیل",
        User: "",
        Status: "",
        Exception: "",
        IsShow: "کاربر مورد نظر",
      },

      timeOffset: null,
      isTimeOffsetMines: null,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    isLoginButtonDisabled() {
      if (this.selectedTimeZone && this.selectedTimeZone.id) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async getCountryLists() {
      try {
        let _this = this;
        let getTimeZoneList = new GetTimeZoneList(_this);
        await getTimeZoneList.fetch((res) => {
          _this.countryList = res;
        });
      } catch (error) {
        console.error(error);
      }
      let tempTimezoneTitle =
        Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
      if (!tempTimezoneTitle) {
        tempTimezoneTitle = "Asia/Tehran";
      }
      this.selectedTimeZone = this.countryList.find(
        (item) => item.orginalTitle == tempTimezoneTitle
      );
    },
    async getUserByToken(userRole) {
      return new Promise(async (resolve, reject) => {
        try {
          let _this = this;
          let getUserByToken = new GetUserByToken(_this);
          await getUserByToken.fetch((res) => {
            let userDetails = res.data;
            userDetails["role"] = userRole;
            resolve(userDetails);
          });
        } catch (error) {
          console.error(error);
          reject(error);
        }
      });
    },
    async getUserAccessList() {
      try {
        //this.isLoading = true;
        let _this = this;
        let getLoginUserAccess = new GetLoginUserAccess(_this);

        await getLoginUserAccess
          .fetch((res) => {
            _this.accessListForRole = res;
          })
          .catch(function (err) {
            console.log(err.response);
          });
      } catch (error) {
        console.log(error, error.response);
      } finally {
        //this.isLoading = false;
      }
    },
    // async setNewTimezone() {
    //   if (
    //     this.selectedTimeZone &&
    //     (this.selectedTimeZone.minute || this.selectedTimeZone.minute == 0)
    //   ) {
    //     await this.convertNumericOffsetToTimeString(
    //       this.selectedTimeZone.minute / 60
    //     );
    //   }
    // },
    async convertNumericOffsetToTimeString(numericOffset) {
      // Calculate hours and minutes
      await new Promise((resolve, reject) => {
        const hours = Math.floor(Math.abs(numericOffset));
        const minutes = Math.floor((Math.abs(numericOffset) - hours) * 60);

        // Format the hours and minutes as "hh:mm:ss"
        const formattedHours = hours.toString().padStart(2, "0");
        const formattedMinutes = minutes.toString().padStart(2, "0");
        // Combine the formatted offset
        const offsetString = `${formattedHours}:${formattedMinutes}:00`;
        this.timeOffset = offsetString;
        this.isTimeOffsetMines = numericOffset >= 0 ? false : true;
        resolve();
      });
    },

    createTimezoneOffset() {
      const offsetMinutes = new Date().getTimezoneOffset();

      // Calculate hours and minutes
      const hours = Math.floor(Math.abs(offsetMinutes / 60));
      const minutes = Math.abs(offsetMinutes % 60);

      // Convert to string format "hh:mm:ss"
      const formattedOffset = `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:00`;

      // Determine if the offset is positive or negative
      this.loginDetails.isTimeOffsetMines = offsetMinutes >= 0 ? false : true;

      this.loginDetails.timeOffset = formattedOffset;
    },
    async login() {
      // await this.setNewTimezone();
      const _this = this;
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          this.showOverlay = true;
          useJwt
            .login({
              mobile: this.mobile,
              mail: "string",
              firstName: "string",
              lastName: "string",
              password: this.password,
              verifyCode: "string",
              encryptedMail: "string",
              userName: "string",
              userRole: 0,
              type: 1,
              isTimeOffsetMines: this.isTimeOffsetMines,
              timeOffset: this.timeOffset,
              // countryTimeZoneId: this.selectedTimeZone.id,
              countryTimeZoneId: 192,
            })
            .then(async (response) => {
              this.showOverlay = false;

              // Errors
              if (response.data.status === 3) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "نام کاربری یا رمز عبور اشتباه است.",
                  },
                });
              } else if (response.data.status === 4) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "کد ارسال شده منتقضی شده است،لطفا دوباره امتحان کنید.",
                  },
                });
              } else if (response.data.status === 5) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "کد وارد شده اشتباه است.",
                  },
                });
              } else if (response.data.status === 6) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "کاربری با این نام کاربری وجود ندارد.",
                  },
                });
              } else if (response.data.status === 8) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "قبلا کاربری با این نام کاربری ثبت نام کرده است.",
                  },
                });
              } else if (response.data.status === 9) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "پسورد شما ایمن نیست.",
                  },
                });
              } else if (response.data.status === 10) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "نام کاربری قبلا ثبت نام کرده است.",
                  },
                });
              } else if (response.data.status === 11) {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "اکانت شما غیرفعال شده است.",
                  },
                });
              }

              // Success
              let userData = response.data.data.identity;
              const userRole = userData.user.role;

              // زبان‌آموز اجازه‌ی ورود به پنل مدیر ندارد؛ استاد برای دیدن درآمد و شاگردهایش وارد می‌شود
              // پیش از ذخیره‌ی توکن بررسی می‌شود تا چیزی ذخیره نشود
              const blockedRoles = ["student"];
              if (blockedRoles.includes(String(userRole || "").toLowerCase())) {
                this.showOverlay = false;
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: "این حساب اجازه‌ی ورود به پنل مدیریت را ندارد.",
                  },
                });
              }

              useJwt.setToken(userData.token);
              useJwt.setRefreshToken(userData.refreshToken);
              localStorage.setItem("userData", JSON.stringify(userData));
              userData.user = await this.getUserByToken(userRole);
              await _this.getUserAccessList();
              userData["ability"] = [
                {
                  action: "common",
                  subject: "common",
                },
                ..._this.accessListForRole,
              ];
              this.$ability.update([
                {
                  action: "common",
                  subject: "common",
                },
                ..._this.accessListForRole,
              ]);
              localStorage.setItem("userData", JSON.stringify(userData));
              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.push("/").then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    title: `خوش آمدید ${userData.user.fullName}`,
                    icon: "CoffeeIcon",
                    variant: "success",
                    text: `شما به عنوان ${userData.user.role} وارد شدید.`,
                  },
                });
              });
            })
            .catch((error) => {
              this.showOverlay = false;
              Object.keys(error?.response?.data?.errors).forEach((item) => {
                return this.$toast({
                  component: ToastificationContent,
                  position: "bottom-left",
                  props: {
                    variant: "danger",
                    text: `${this.signInKeys[item]} ${
                      this.signInErrors[error.response.data.errors[item]]
                    }`,
                  },
                });
              });
            });
        }
      });
    },
  },
};
import { GetLoginUserAccess } from "@/libs/Api/UserType";
import { GetTimeZoneList } from "@/libs/Api/Country";
import { GetUserByToken } from "@/libs/Api/Users";
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
<style scoped>
label {
  margin-bottom: 0 !important;
}
</style>
